import { URL_INFURA, cortador } from "../helpers";
import ShowTotalCart from "./ShowTotalCart";
import ButtonCart from "./ButtonCart";


const styles = {
  detallesCarro: {
    position: "absolute",
    marginTop: "10px",
    backgroundColor: "#fdffe0",
    boxShadow: "1px 5px 5px rgb(0,0,0,0.3)",
    borderRadius: "5px",
    right: 40,
    width: "300px",
    zIndex: 1,
  },
  ul: {
    margin: 0,
    padding: 0,
  },
  producto: {
    listStyleType: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 5px",
    borderBottom: "1px solid lightgrey",
  },
  totalContainer: {
    backgroundColor: "#FFF",
    padding: "10px 10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: "bold",
    color: "#333",
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
};
export default function CartDetails({ carrito, toggleIsVisible }) {
  const style = {
    font: { color: "#333" },
    cantidad: {
      color: "#C00",
    },
  };

  return (
    <div style={styles.detallesCarro}>
      <ul style={styles.ul}>
        {carrito.map((x) => (
          <li style={styles.producto} key={x.id}>
            <span>
              <img
                alt={x.title}
                src={`${URL_INFURA}${x.url_image_1}`}
                width="50"
                height="62"
              />
            </span>
            <span style={style.font}>
              {cortador(x.title)}
              <small>({x.cantidad})</small>
            </span>
            <p style={style.cantidad}>${x.price * x.cantidad}</p>
          </li>
        ))}
      </ul>
      <div style={styles.totalContainer}>
        Total :
        <ShowTotalCart carrito={carrito} />
      </div>
      <div style={styles.buttonsContainer}>
        <ButtonCart toggleIsVisible={toggleIsVisible} url="/view-cart">View Cart</ButtonCart>
        <ButtonCart toggleIsVisible={toggleIsVisible} url="/checkout">CHECK OUT</ButtonCart>
      </div>
    </div>
  );
}
